import React from 'react'
import styled from 'styled-components'
import { CollaboTitleText } from 'src/components/Global/Text/TitleText'
import { CollaboCard, CollaboInfoCard } from 'src/components/Global/Cards/Cards'
import { CollaboIconT } from 'src/assets'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import { Link, useLocation } from 'react-router-dom'
const CollaboHeaderWrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  .plus {
    font-weight: 800;
    font-size: ${({ theme }) => theme.fontSize.xx5};
    line-height: 34px;
    letter-spacing: 1px;
    color: ${({ theme }) => theme.colors.gray};
    padding: 35px 0px;
    cursor: pointer;
  }
  h2 {
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    font-style: normal;
    font-weight: bold;
    font-size: ${({ theme }) => theme.fontSize.xx1};
    line-height: 34px;
    letter-spacing: 1px;
    color: ${({ theme }) => theme.colors.white};
    padding: 5px 0px;
  }
  .header {
    display: flex;
  }
  p {
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 34px;
    letter-spacing: 1px;
    color: ${({ theme }) => theme.colors.gray};
    width: 311px;
  }
  .mb {
    display: none;
  }
  @media (max-width: 1150px) {
    .mb {
      display: flex;
      margin-right: -32px;
    }
    .lg {
      display: none;
    }
  }
`
const CollaboHeader = () => {
  let location = useLocation()
  return (
    <CollaboHeaderWrapper>
      <CollaboTitleText>Collabo</CollaboTitleText>
      <div className="header mb">
        <Swiper
          breakpoints={{
            300: {
              slidesPerView: 1.1,
              spaceBetween: 0,
            },
            501: {
              slidesPerView: 1.2,
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 1.5,
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 1.7,
            },
            1150: {
              slidesPerView: 1.8,
            },
          }}
          spaceBetween={0}
          slidesPerView={2}
          onSlideChange={() => console.log('slide change')}
          onSwiper={(swiper) => console.log(swiper)}
        >
          <SwiperSlide>
            <CollaboCard>
              <h2>Start Collabo</h2>
              <Link
                to={`/big/create-collabo`}
                state={{ backgroundLocation: location }}
              >
                <h1 className="plus">+</h1>
              </Link>
            </CollaboCard>
          </SwiperSlide>
          <SwiperSlide>
            <CollaboInfoCard>
              <p>
                Collabo towards money goals with your friends, colleagues and
                family. Start your collabo now.
              </p>
              <img src={CollaboIconT} alt="" />
            </CollaboInfoCard>
          </SwiperSlide>
          ...
        </Swiper>
      </div>
      <div className="header lg">
        <CollaboCard>
          <h2>Start Collabo</h2>
          <Link to={`/create-collabo`} state={{ backgroundLocation: location }}>
            <h1 className="plus">+</h1>
          </Link>
        </CollaboCard>
        <CollaboInfoCard>
          <p>
            Collabo towards money goals with your friends, colleagues and
            family. Start your collabo now.
          </p>
          <img src={CollaboIconT} alt="" />
        </CollaboInfoCard>
      </div>
    </CollaboHeaderWrapper>
  )
}

export { CollaboHeader }
